import React from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { capitalizeFirstLetter } from "../../../shared/utils/util";

const Step5Review: React.FC = () => {
	const { t } = useTranslation();
	const { watch } = useFormContext();
	const formData = watch();

	const renderField = (label: string, value: any) => {
		if (!value || value === "") return null;

		const displayValue =
			typeof value === "object"
				? JSON.stringify(value)
				: capitalizeFirstLetter(String(value));

		return (
			<div className="review-field d-flex">
				<strong>{label}:</strong> <p>{displayValue}</p>
			</div>
		);
	};

	return (
		<div className="step-content">
			<h2>{t("createJob.step5.title", "Review & Publish")}</h2>

			<div className="review-section w-100">
				<h3>{t("createJob.step5.summary")}</h3>
				{renderField(t("createJob.review.subject"), formData.subject)}
				{renderField(t("createJob.review.sport"), t(`sportData.sportsLabels.${formData.sport}`))}
				{renderField(t("createJob.categoryLabel"), formData.category)}
				{renderField(
					t("createJob.review.position"),
					t(`sportData.positions.${formData.sport}.${formData.position}`)
				)}
				{renderField(t("common.words.location"), formData.city)}
				{formData.league &&
					formData.category &&
					renderField(t("createJob.review.league"), `${formData.league} (${formData.category})`)}
				{renderField(
					t("createJob.review.availableToTransfer"),
					formData.availableToTransfer ? t("common.words.yes") : t("common.words.no")
				)}
				{renderField(t("createJob.review.cartellinoStatus"), formData.cartellinoStatus)}
				{formData.description && formData.description.trim() !== "" && (
					<div className="review-field description-field">
						<strong>{t("createJob.review.description")}:</strong>
						<div className="description-preview">{formData.description}</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default Step5Review;
